export default __webpack_public_path__ + "static/media/bpiece.9e0bec2c.png";